import React from 'react';
import { Box, styled, Container } from '@mui/material';
import Footer from './Footer';

const Main = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
});

const Content = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const Header = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  borderBottom: '1px solid #e0e0e0',
}));

const Logo = styled('img')({
  height: '30px',
  display: 'block',
});

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Main>
      <Header>
        <Container maxWidth="lg">
          <a href="https://zgallerie.com/" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
            <Logo 
              src="https://img-va.myshopline.com/image/store/1745820125227/zgallerie-logo.svg" 
              alt="Z Gallerie" 
            />
          </a>
        </Container>
      </Header>
      <Content>
        {children}
      </Content>
      <Footer />
    </Main>
  );
};

export default Layout; 